import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/admin/analytics")({
  component: lazyRouteComponent(() => import("@/pages/admin/Analytics")),
});
